import { create } from 'zustand';

const loadState = () => {
  try {
    const savedState = localStorage.getItem('modelTransformParams');
    return savedState ? JSON.parse(savedState) : undefined;
  } catch (err) {
    console.error("Could not load model transform state", err);
    return undefined;
  }
};

// Initial state based on current App.jsx values (adjust if needed)
const initialState = {
  posX: 5, posY: 0.5, posZ: -2,
  rotX: 0, rotY: Math.PI / 2, rotZ: 0,
  scale: 1.97,
};

const useModelStore = create((set) => ({
  ...(loadState() || initialState),

  setPosition: (x, y, z) => set({ posX: x, posY: y, posZ: z }),
  setRotation: (x, y, z) => set({ rotX: x, rotY: y, rotZ: z }),
  setScale: (s) => set({ scale: Math.max(0.01, s) }), // Ensure scale doesn't go to zero
  
  // Individual setters for Leva compatibility
  setPosX: (val) => set({ posX: parseFloat(val) || 0 }),
  setPosY: (val) => set({ posY: parseFloat(val) || 0 }),
  setPosZ: (val) => set({ posZ: parseFloat(val) || 0 }),
  setRotX: (val) => set({ rotX: parseFloat(val) || 0 }),
  setRotY: (val) => set({ rotY: parseFloat(val) || 0 }),
  setRotZ: (val) => set({ rotZ: parseFloat(val) || 0 }),

}));

export const saveModelTransformState = () => {
  try {
    const stateToSave = useModelStore.getState();
    // Save only the core parameters
    const paramsOnly = {
      posX: stateToSave.posX,
      posY: stateToSave.posY,
      posZ: stateToSave.posZ,
      rotX: stateToSave.rotX,
      rotY: stateToSave.rotY,
      rotZ: stateToSave.rotZ,
      scale: stateToSave.scale,
    };
    localStorage.setItem('modelTransformParams', JSON.stringify(paramsOnly));
    console.log("Model transform params saved to localStorage");
  } catch (err) {
    console.error("Could not save model transform state", err);
  }
};

export default useModelStore; 